// Card that takes children components to display in a dashboard layout
// It will take a title, descripiton (to be in tooltip), and optional action  buttons, an icon and then display the children
import {
  Card,
  CardHeader,
  CardContent,
  Tooltip,
  Box,
  Typography,
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
const DashboardCard = (props) => {
  const { title, description, children, icon, actions, sx } = props;
  return (
    <Card variant="outlined" sx={sx}>
      <CardHeader
        avatar={icon}
        action={actions}
        title={
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="h6">{title}</Typography>
            {description && (
              <Tooltip title={description} placement="top">
                <InfoOutlinedIcon
                  fontSize="small"
                  sx={{ color: (theme) => theme.palette.text.secondary }}
                />
              </Tooltip>
            )}
          </Box>
        }
      />
      <CardContent>{children}</CardContent>
    </Card>
  );
};

export default DashboardCard;
